import { render, staticRenderFns } from "./_tabDocuments.vue?vue&type=template&id=4087fa42&"
import script from "./_tabDocuments.vue?vue&type=script&lang=js&"
export * from "./_tabDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports